import { useTranslation } from "react-i18next";

import { FieldNumber } from "@/ui/field-number";

import { EditorDefaultFields } from "../schema-builder-field-editor-default";

export const EditorTextareaFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <EditorDefaultFields />
      <FieldNumber name="max" label={t(`schema:property.max`)} min={1} />
      <FieldNumber name="rows" label={t(`schema:property.rows`)} min={1} />
    </>
  );
};
